import React from 'react';
import { SvgIcon } from '@mui/material';

function BinOutlinedIcon(props) {
  return (
    <SvgIcon
      width="11"
      height="6"
      viewBox="0 0 11 6"
      fontSize="12px"
      sx={{
        width: props.width || '15px',
        height: props.height || '7px',
        color: props.color || '#A3B4C7',
        marginRight: '8px'
      }}
    >
      <path
        /* eslint-disable-next-line max-len */
        d="M10.8846 0.5H9.79903C9.72521 0.5 9.65574 0.524414 9.61232 0.564453L5.50027 4.38867L1.38823 0.564453C1.34481 0.524414 1.27534 0.5 1.20152 0.5H0.115975C0.0218942 0.5 -0.0331067 0.572266 0.0218942 0.624024L5.1254 5.37109C5.31067 5.54297 5.68988 5.54297 5.8737 5.37109L10.9772 0.624024C11.0337 0.572266 10.9787 0.5 10.8846 0.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default BinOutlinedIcon;
